import { render, staticRenderFns } from "./VendorDetail.vue?vue&type=template&id=12737a45&scoped=true"
import script from "./VendorDetail.vue?vue&type=script&lang=js"
export * from "./VendorDetail.vue?vue&type=script&lang=js"
import style0 from "./VendorDetail.vue?vue&type=style&index=0&id=12737a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12737a45",
  null
  
)

export default component.exports